// src/hooks/useSocket.js
import { COMMANDS } from '../../utils/commonProperties';
import * as THREE from 'three';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCommandMessage, resetOperation } from '../../redux/operationSlice';
import { generateUniqueId } from '../../utils/generateUniqueId';
import { createGroundingStrake } from '../../factory/symbols/createGroundingStrake';
 import useSnapPoints from '../../shared/snap/useSnapPoints';
import { useGroundingWiring } from '../../modules/wiring';
  

const useGrounding = (scene, camera, renderer) => {
  const dispatch = useDispatch();
  const { commandType } = useSelector((state) => state.operation);
  const { snapPoints } = useSnapPoints(scene);

  const dynamicSnapPoints = useRef([]);
  const wiringActiveRef = useRef(false);
  const sceneRef = useRef(null);
  const placedSocketsRef = useRef([]);
  const getOffsetPositionAtDirection = (base, direction, width = 14, height = 28) => {
    return base.clone().add(
      new THREE.Vector3(-direction.x * (width / 2), -direction.y * (height / 2), 0)
    );
  };

  const handleSocketPlace = (position, direction) => {
    const adjustedPos = getOffsetPositionAtDirection(position, direction);
    const socket = createGroundingStrake(sceneRef.current, adjustedPos, direction, 0x0045ff, false, "normal", null, 45);
    const angle = Math.atan2(direction.y, direction.x);
    socket.children[0].rotation.z = angle;

    socket.userData = {
      id: generateUniqueId(),
      type: 'groundingStrake',
      isSelectable: true,
      originalColor: 0x0045ff,
      connectedFrom: null,
      connectedTo: position.clone(),
    };

    sceneRef.current.add(socket);
    return socket;
  };

  const handleSocketRemove = (socket) => {
    if (!socket) return;
    sceneRef.current.remove(socket);
    socket.traverse(child => {
      if (child.geometry) child.geometry.dispose();
      if (child.material) child.material.dispose();
    });
  };
 
  const handlePreviewUpdate = (point) => {
    if (!sceneRef.current || !point || placedSocketsRef.current.length < 1) return;

    const lastSocket = placedSocketsRef.current[placedSocketsRef.current.length - 1];
    if (!lastSocket) return;

    const direction = new THREE.Vector3().subVectors(point, lastSocket.userData.connectedTo).normalize();
    const angle = Math.atan2(direction.y, direction.x);

    lastSocket.children[0].rotation.z = angle;
    lastSocket.position.copy(getOffsetPositionAtDirection(point, direction));
  };
 


  const handleWireEnd = (vertices, sockets, source, tempLineUUID) => {


    scene.traverse((obj) => {
      if (
        obj.type === 'Group' &&
        obj.userData?.type === 'groundingBuatLabel' &&
        obj.userData?.isPreview === true
      ) {
        obj.userData.isPreview = false;
      }
    });

          dispatch(resetOperation());
                wiringActiveRef.current = false;
   

  };








  useEffect(() => {
     

    if (commandType !== COMMANDS.DRAW_GROUNDINGSTRIP || !scene || !camera || !renderer) return;
   

    dispatch(setCommandMessage('Soket hattı çizin, Space ile soket ekleyin, Enter ile bitirin.'));
    sceneRef.current = scene;

    dynamicSnapPoints.current = [];
    scene.traverse(obj => {
      if (obj.userData?.connectionPoints) {
        obj.userData.connectionPoints.forEach(p => {
          if (p.type === 'panelCon_out') {
            const worldPos = p.position.clone().applyMatrix4(obj.matrixWorld);
            dynamicSnapPoints.current.push({
              no: obj.uuid,
              position: worldPos,
              type: 'panelConnection',

            });
          }
        });
      }
    });

    wiringActiveRef.current = true;
  }, [commandType, scene, camera, renderer]);

  useGroundingWiring(
    scene,
    camera,
    renderer,
    [...snapPoints, ...dynamicSnapPoints.current],
    {
      enabled: () => wiringActiveRef.current,
      onWireEnd: handleWireEnd,
      onSocketPlace: handleSocketPlace,
      onSocketRemove: handleSocketRemove,
      onPreviewUpdate: handlePreviewUpdate,
      onWireCancel: () => {
        wiringActiveRef.current = false; // ESC ile iptal edildiğinde devre dışı bırak
      }
    }
  );
};

export default useGrounding; 